import * as React from 'react'
import { useWrapperStore } from '../../store/storeWrapper'
import { Notistack } from '../Notistack'

export const WrapperNotification: React.FC<React.PropsWithChildren> = ({ children }) => {
    const {
        isOpenNotification,
        isNotificationError,
        setStateNotification,
        notificationText,
        notificationAction,
    } = useWrapperStore((state) => state)

    const handleCloseNotification = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return
        }

        setStateNotification({ isOpen: false, text: undefined, isError: false })
    }

    return (
        <>
            {children}
            <Notistack
                action={notificationAction}
                open={isOpenNotification}
                isError={isNotificationError}
                message={notificationText}
                onClose={handleCloseNotification}
            />
        </>
    )
}
